import CustomActiu from "../pages/CustomActiu";
import CustomElement from "../pages/CustomElement";
import CustomInstallacio from "../pages/CustomInstallacio";
import CustomTicketing from "../pages/CustomTicketing";
import CustomContractes from "../pages/CustomContractes";
import CustomPlanificador from "../pages/CustomPlanificador";
import CustomEmpresa from "../pages/CustomEmpresa";
import CustomTicketingTreball from "../pages/CustomTicketingTreball";
import CustomUsuari from "../pages/CustomUsuari";
import CustomModals from "../pages/CustomModals";
import CustomRecertification from "../pages/CustomRecertification";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import Searcher from "../pages/Searcher";
import CustomActiuTelegestio from "../pages/CustomActiuTelegestio";
import CustomInstallacioTelegestio from "../pages/CustomInstallacioTelegestio";
import CustomElementTelegestio from "../pages/CustomElementTelegestio";
import EfpaReport from "../pages/EfpaReport";
import CustomMassiveEmail from "../pages/CustomMassiveEmail";
import CustomPlanificationsReportSearcher from "../pages/CustomPlanificationsReportSearcher";
import CustomPlanificationsReportSearcherCartera from "../pages/CustomPlannificationsReportSearcherCartera";
import CustomPlanificationsCostCenters from "../pages/CustomPlanificationsCostCenters";
import CustomPlanificationsObjectives from "../pages/CustomPlanificationsObjectives";
import CustomPlanificationsObjectivesNewContract from "../pages/CustomPlanificationsObjectivesNewContract";
import CustomPlanificationsObjectivesAdditionals from "../pages/CustomPlanificationsObjectivesAdditionals";
import CustomPlanificationsTracingContract from "../pages/CustomPlanificationsTracingContract";
import CustomPlanificationsTracingAggregate from "../pages/CustomPlanificationsTracingAggregate";
import CustomPlanificationsDashboard from "../pages/CustomPlanificationsDashboard";
import CustomHomeRubatec from "../pages/CustomHomeRubatec";
import CustomPlanificationsTemporalDistribution from "../pages/CustomPlanificationsTemporalDistribution";
import CustomPlanificationsTemporalDistributionAggregate from "../pages/CustomPlanificationsTemporalDistribution/CustomPlanificationsTemporalDistributionAggregate";
import CustomSar from "../pages/CustomSar/CustomSar";
import CustomRecertificationTestStatics from "../pages/CustomStatistics/CustomRecertificationTestStatics";
import CustomTestStatics from "../pages/CustomStatistics/CustomTestStatics";
import CustomAulaVirtualStatics from "../pages/CustomStatistics/CustomAulaVirualStatics";
import CustomAltasExamenesStatics from "../pages/CustomStatistics/CustomAltasExámenesStatistics";
import CustomBbvaUsageStatistics from "../pages/CustomStatistics/CustomBbvaUsageStatistics";
import CustomPlanificationsTreasuryForecast
  from "../pages/CustomPlanificationsTreasuryForecast/CustomPlanificationsTreasuryForecast";
import CustomMobilityReports from "../pages/CustomMobilityReports";
import CustomWorkshopsMoveToBackup from "../pages/CustomWorkshopsMoveToBackup";

let dynamic_routes = [];
if (process.env.REACT_APP_CUSTOM_HOME) {
  //import CustomHome from "../pages/"+process.env.REACT_APP_CUSTOM_HOME;
  //const CustomHome = React.lazy(() => import('../pages/'+process.env.REACT_APP_CUSTOM_HOME));
  //const CustomHome = await import('../pages/'+process.env.REACT_APP_CUSTOM_HOME);
  dynamic_routes = [
    {
      id: "home-custom",
      path: "/",
      exact: true,
      view: CustomHomeRubatec,
    },
    {
      id: "EfpaReport",
      path: "/efpa-reporte",
      exact: true,
      view: EfpaReport,
      custom: true
    },
    {
      id: "404",
      path: "*",
      view: NotFound,
    },
    {
      id: "home",
      path: "/home",
      view: Home,
    },
  ];
} else {
  dynamic_routes = [
    {
      id: "home",
      path: "/",
      exact: true,
      view: Home,
    },
    {
      id: "EfpaReport",
      path: "/efpa-reporte",
      exact: true,
      view: EfpaReport,
      custom: true
    },
    {
      id: "404",
      path: "*",
      view: NotFound,
    },
  ];
}

const ROUTES_CONFIG = [
  ...dynamic_routes,
  {
    id: "asset",
    path: "/custom-actiu/:id",
    view: CustomActiu,
    custom: true
  },
  {
    id: "asset_telegestio",
    path: "/custom-actiu-telegestio/:id",
    view: CustomActiuTelegestio,
    custom: true
  },
  {
    id: "installation",
    path: "/custom-installacio/:id",
    view: CustomInstallacio,
    custom: true
  },
  {
    id: "installation_telegestio",
    path: "/custom-installacio-telegestio/:id",
    view: CustomInstallacioTelegestio,
    custom: true
  },
  {
    id: "element",
    path: "/custom-element/:id",
    view: CustomElement,
    custom: true
  },
  {
    id: "element_telegestio",
    path: "/custom-element-telegestio/:id",
    view: CustomElementTelegestio,
    custom: true
  },
  {
    id: "ticketing",
    path: "/detalls-ticketing/:id",
    view: CustomTicketing,
    custom: true
  },
  {
    id: "contractes",
    path: "/custom-contracte/:id",
    view: CustomContractes,
    custom: true
  },
  {
    id: "empresa",
    path: "/companies/managers/:id",
    view: CustomEmpresa,
    custom: true
  },
  {
    id: "clients",
    path: "/companies/clients/:id",
    view: CustomEmpresa,
    custom: true
  },
  {
    id: "planificador",
    path: "/detalls-planificador/:id",
    view: CustomPlanificador,
    custom: true
  },
  {
    id: "ticketingTreball",
    path: "/detalls-ticketing-treball/:id",
    view: CustomTicketingTreball,
    custom: true
  },
  {
    id: "usuari",
    path: "/detalls-usuari/:id",
    view: CustomUsuari,
    custom: true
  },
  {
    id: "modals",
    path: "/custom-modals/:id",
    view: CustomModals,
    custom: true
  },
  {
    id: "recertification",
    path: "/custom-recertification/:id",
    view: CustomRecertification,
    custom: true
  },
  {
    id: "searcher",
    path: "/searcher",
    view: Searcher,
    custom: true
  },
  {
    id: "massive-email",
    path: "/custom-massive-email/:id",
    view: CustomMassiveEmail,
    custom: true
  },
  {
    id: "sar",
    path: "/panel-sar/",
    view: CustomSar,
    custom: true
  },
  {
    id: "informes-planificacio",
    path: "/informes-planificacio",
    view: CustomPlanificationsReportSearcher,
    custom: true
  },
  {
    id: "informes-planificacio-cartera",
    path: "/informes-planificacio-cartera",
    view: CustomPlanificationsReportSearcherCartera,
    custom: true
  },
  {
    id: "informes-centres-cost",
    path: "/informes-centres-cost",
    view: CustomPlanificationsCostCenters,
    custom: true
  },
  {
    id: "planificacio-objectius",
    path: "/planificacio-objectius",
    view: CustomPlanificationsObjectives,
    custom: true
  },
  {
    id: "planificacio-objectius-nova-contractacio",
    path: "/planificacio-objectius-nova-contractacio",
    view: CustomPlanificationsObjectivesNewContract,
    custom: true
  },
  {
    id: "planificacio-objectius-adicionals",
    path: "/planificacio-objectius-adicionals",
    view: CustomPlanificationsObjectivesAdditionals,
    custom: true
  },
  {
    id: "planificacio-seguiment-contracte",
    path: "/planificacio-seguiment-contracte",
    view: CustomPlanificationsTracingContract,
    custom: true
  },
  {
    id: "planificacio-seguiment-agregat",
    path: "/planificacio-seguiment-agregat",
    view: CustomPlanificationsTracingAggregate, 
    custom: true
  },
  {
    id: "planificacio-dashboard",
    path: "/planificacio-dashboard",
    view: CustomPlanificationsDashboard,
    custom: true
  },
  {
    id: "planificacio-distribucio-temporal",
    path: "/planificacio-distribucio-temporal",
    view: CustomPlanificationsTemporalDistribution,
    custom: true
  },
  {
    id: "planificacio-distribucio-temporal-agregat",
    path: "/planificacio-distribucio-temporal-agregat",
    view: CustomPlanificationsTemporalDistributionAggregate,
    custom: true
  },
  {
    id: 'planificacio-previsio-produccio',
    path: '/planificacio-previsio-produccio',
    view: CustomPlanificationsTreasuryForecast,
    custom: true
  },
  {
    id: "analitica-mobilitat",
    path: "/analitica-mobilitat",
    view: CustomMobilityReports,
    custom: true
  },
  {
    id: "test-recertification-stats",
    path: "/test-recertification-stats",
    view: CustomRecertificationTestStatics,
    custom: true
  },
  {
    id: "test-stats",
    path: "/test-stats",
    view: CustomTestStatics,
    custom: true
  },
  {
    id: "test-optativo-stats",
    path: "/test-optativo-stats",
    view: CustomAulaVirtualStatics,
    custom: true
  },
  {
    id: "altas-examenes-stats",
    path: "/altas-examenes-stats",
    view: CustomAltasExamenesStatics,
    custom: true
  },
  {
    id: "bbva-usage-stats",
    path: "/bbva-usage-stats",
    view: CustomBbvaUsageStatistics,
    custom: true
  },
  {
    id: "workshops-move-to-backup",
    path: "/workshops-move-to-backup",
    view: CustomWorkshopsMoveToBackup,
    custom: true
  },
];

// Obtener rutas con custom: true (para control de navegación)
export const getCustomRoutes = () => {
  return ROUTES_CONFIG
    .filter(route => route.custom === true)
    .map(route => {
      const path = route.path.replace(/:[^/]+/g, '');
      return path.endsWith('/') ? path : path + '/';
    });
};

export default ROUTES_CONFIG;
